
import React from 'react';

interface LoadingStateViewProps {
  showAsAdmin: boolean;
}

const LoadingStateView: React.FC<LoadingStateViewProps> = ({ showAsAdmin }) => {
  return (
    <div className="flex justify-center my-12">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
  );
};

export default LoadingStateView;
